import { render, staticRenderFns } from "./DiviseurLogo.vue?vue&type=template&id=6830bf2c&"
import script from "./DiviseurLogo.vue?vue&type=script&lang=js&"
export * from "./DiviseurLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports